<template>
	<v-header title="帮助" :headerLeftStatus="true" />
	<div class="sysMain">
		<!-- <h3>这种情况：报告未生成,无法查看</h3>
		<img :src="require('../../static/img/help1.png')"/><br/>
		<h3>这种情况：报告已经生成，可以查看报告。 根据不同得手机情况，如果点报告下载。没效果，可以点击报告地址，复制报告地址到浏览器黏贴回车。直接查看或下载报告</h3>
		<img :src="require('../../static/img/help2.png')"/><br/>
		<h3>绑定家人信息：方便查看家人体检报告</h3>
		<h3>第一步点击新增</h3>
		<img :src="require('../../static/img/help3.png')"/><br/>
		<h3>第二步：录入家人信息(备注：身份证是家人得身份证，手机号是体检预留得手机号)
		信息录入完点击提交</h3>
		<img :src="require('../../static/img/help4.png')"/> -->
		
		<h3>这种情况：报告未生成,无法查看</h3>
		<img :src="require('../../static/img/help1.png')"/><br/>
		<h3>这种情况：报告已经生成，可以查看报告。 根据不同得手机情况，如果点报告下载。没效果，可以点击报告地址，复制报告地址到浏览器黏贴回车。直接查看或下载报告</h3>
		<img :src="require('../../static/img/help2.png')"/><br/>
		<h3>绑定家人信息：方便查看家人体检报告</h3>
		<h3>第一步点击新增</h3>
		<img :src="require('../../static/img/help3.png')"/><br/>
		<h3>第二步：录入体检信息(备注：体检号，体检人姓名)
		信息录入完点击提交</h3>
		<img :src="require('../../static/img/help5.png')"/>
	</div>
</template>

<script>
	import header from "@/components/header/index";
	export default {
		name: 'patient',
		data() {
			return {
			};
		},
		created() {
		},
		methods: {
		},
		components: {
			"v-header": header
		}
	}
</script>
